import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { deleteCoreAiAgentSlice } from './delete';
import { getCoreAiAgentSlice } from './get';

import { coreAiAgentToolsReducers, coreAiAgentToolsWatchers } from './tools';

export const coreAiAgentReducers = combineReducers({
	delete: deleteCoreAiAgentSlice.asyncReducers,
	get: getCoreAiAgentSlice.asyncReducers,
	tools: coreAiAgentToolsReducers
});

export const coreAiAgentWatchers = combineAllWatchers([
	deleteCoreAiAgentSlice.asyncWatchers,
	getCoreAiAgentSlice.asyncWatchers,
	coreAiAgentToolsWatchers
]);
